import { toggleMark } from "prosemirror-commands";
import { MenuItem } from "prosemirror-menu";
import type { MarkType } from "prosemirror-model";

import { isFormulaSelected, isImageSelected, isSelectionInCodeBlock, markActive } from "../utils";

import type { ProseMirrorIcon } from "mds/utils/toolbar-icons";

/**
 * Create a menu item for toggling a mark (bold, italic, code, etc.)
 *
 * Menu items have three key properties:
 * - active: Whether the item should appear highlighted (mark is currently applied)
 * - enable: Whether the item is clickable (can the mark be toggled in current context)
 * - run: What happens when the item is clicked (toggles the mark)
 *
 * @param markType - The mark type to toggle (e.g., schema.marks.bold)
 * @param options - Display options (title for tooltip, icon for button)
 * @returns A MenuItem that can be added to the toolbar
 */
export function markItem(markType: MarkType, options: { title: string; icon: ProseMirrorIcon }) {
  return new MenuItem({
    title: options.title,
    icon: options.icon,
    // Highlight the button when the mark is active in the current selection
    active(state) {
      return markActive(state, markType);
    },
    enable(state) {
      return !isSelectionInCodeBlock(state) && !isFormulaSelected(state) && !isImageSelected(state);
    },
    // Toggle the mark when the button is clicked
    run(state, dispatch) {
      return toggleMark(markType)(state, dispatch);
    },
  });
}
